export default __webpack_public_path__ + "static/media/Destination6.b43b40eb.png";